<template>
  <v-dialog v-model="dialog" width="900px">
    <v-card>
      <p class=".title ma-2">Whatsapp messages to / from Guest</p>

      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th>Date/time</th>
              <th>Description</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(whap, i) in huov.whap" :key="i" @click="$router.open('/whap/showWhap/' + whap.whap_encrid)" style="cursor: pointer;">
              <td>{{ whap.whap_dt }}</td>
              <td>{{ whap.whap_oms }}</td>
              <td>{{ whap.whap_status }}</td>
              <!-- <td>
                  <v-chip :color="mail.mlrc_id" text-color="white">
                    <v-avatar left>
                      <v-icon v-if="mail.mlrc_id === 'success'"
                        >mdi-checkbox-marked-circle</v-icon>
                      <v-icon v-else
                        >mdi-close-circle</v-icon>  
                    </v-avatar>
                    {{ mail.mlrc_dt }}
                  </v-chip>
                </td> -->
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      huov: {},
    }
  },
  methods: {
    open(huov_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/getHuovGuestWhap.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovGuestWhap",
          },
          getHuovGuestWhap: {
            huov_encrid: huov_encrid,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovGuestWhap;
          }
        })
    },
  },
};
</script>

